import { useGetSupportUrl } from '@/hooks/useGetSupportUrl';
import { useAuth } from '@/services/auth';
import { useEffect } from 'react';

const SupportPage = () => {
    const { isAuthenticated, loginWithRedirect } = useAuth();

    const supportUrl = useGetSupportUrl();

    useEffect(() => {
        if (!isAuthenticated) {
            loginWithRedirect({ appState: { returnTo: window.location.href } });
        } else {
            window.location.href = supportUrl;
        }
    }, [supportUrl]);

    return null;
};

export default SupportPage;
